
//:key="$route.fullPath"
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class workplans extends Vue {
  name: String = "workplans";
}
